import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NewsEventsGridPagination as NewsEventsGridPaginationCommon, } from '@yme/organisms/news-events-grid';
import { getCommonLabels, getRootLang, getRTL } from '@yme/selectors/common';
import { setGridType } from './redux/actions';
import { getNewsEventsArticles, getNewsEventsArticlesLoadedStatus, getNewsEventsArticlesLoadingStatus, } from './redux/selectors';
import { getNewsEventsArticlesRequest } from './redux/services';
export function NewsEventsGridPagination(props) {
    const { title, categories, yearFrom, labels, gridType, isRemoveBottomIndent } = props;
    const dataForGridSettings = {
        title,
        categories,
        yearFrom,
        labels,
        gridType,
        isRemoveBottomIndent,
    };
    const dispatch = useDispatch();
    const newsArticles = useSelector(getNewsEventsArticles);
    const isLoading = useSelector(getNewsEventsArticlesLoadingStatus);
    const isLoaded = useSelector(getNewsEventsArticlesLoadedStatus);
    const isRightToLeft = useSelector(getRTL);
    const language = useSelector(getRootLang);
    const commonLabels = useSelector(getCommonLabels);
    const requestCallback = useCallback((dataRequest) => {
        dispatch(getNewsEventsArticlesRequest(dataRequest, {
            isPaginationEnabled: true,
        }));
    }, [dispatch]);
    useEffect(() => {
        dispatch(setGridType(gridType));
    }, [dispatch, gridType]);
    return (React.createElement(NewsEventsGridPaginationCommon, { articlesData: newsArticles, isLoading: isLoading, isLoaded: isLoaded, dataForGridSettings: dataForGridSettings, isRightToLeft: isRightToLeft, language: language, requestCallback: requestCallback, commonLabels: commonLabels }));
}
